module.exports = __webpack_public_path__ + "static/media/sfuidisplay-medium-webfont.d0458711.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/sfuidisplay-medium-webfont.woff
// module id = 260
// module chunks = 0